import React, { useEffect, useState, Suspense, lazy } from 'react'
import { Route, Routes, useNavigate } from 'react-router'
import { ContaianeFalse, MainStyled } from 'components/Main/Main.styled'
import Aside from 'components/Aside/Aside'
import SuperAdminRoutes from 'routes/SuperAdminRoutes'
import { PassCrudProvider } from 'context/PassCrudContext'
import { FormCrudCRUDProvider } from 'context/FormCrudContex'
import { GestionCrudProvider } from 'context/GestionCrudContext'
import { ProductCRUDProvider } from 'context/ProductCRUDContext'
import { CustomsCrudProvider } from 'context/CustomsCrudContext'
import { ProcessCrudProvider } from 'context/ProcessCrudContext'
import { ThirdPartiesProvider } from 'context/ThirdPartiesContext'
import { ConfigurationCRUDProvider } from 'context/ConfigurationCRUDContext'
import { BlockingCRUDProvider } from 'context/BlockingContex'
import { IntegracionBoxCRUDProvider } from 'context/IntegracionBoxCrudContex'
import { TreasuryCRUDProvider } from 'context/TreasuryContex'
import { ReturnReasonnProvider } from 'context/ReturnReasonContext'
import { WeighingProvider } from 'context/WeighingContext'
import { InventoryControlProvider } from 'context/InventoryControlContext'
import { DianCRUDProvider } from 'context/DianCrudContext'
import { StatisProvider } from 'context/StatisContext'
import { MonitoringContextProvider } from 'context/MonitoringContext'
import { OrderProductionProvider } from 'context/OrderProductionContext'
import { FirstLoginProvider } from 'context/FirstLoginContext'
import { ControlAnalysisProvider } from 'context/ControlAnalysis'
import { GlobalContextProvider } from 'context/GlobalContext'
import { SecurityRoutes } from './SecurityRoute'
import Header from 'components/Header/Header'
import { Th, useDisclosure } from '@chakra-ui/react'
import { useModal } from 'hooks/useModal'
import { useLocation } from 'react-router-dom'
import { ADDLocalStorage, GetLocalStorage } from 'hooks/useLocalStorage'
import { useSelector, useDispatch } from 'react-redux'
import { AlertErrorAlert } from 'components/Alerts/AlertErrorAlert'
import { TokenExpirer } from 'components/Token/TokenExpirer'
import { handleLogout } from 'components/Logout/FuncionLogout'
import updateToken from 'redux/actions/renewTokenActions'
import { isValid } from 'utils/parseFloat'
import Loading from 'components/Loading/Loading'
import { EstadisticasOperacionesGeneral } from 'pages/Statistics/operacionesGeneral/EstadisticasOperacionesGeneral';

// Lazy load all page components
const Pases = lazy(() => import('pages/Pass-Form/Pases'))
const Unidad = lazy(() => import('pages/Configuration/views/Unidad'))
const ThirdParties = lazy(() => import('pages/Terceros/ThirdParties'))
const FormuIntEdit = lazy(() => import('pages/Pass-Form/FormuIntEdit').then(module => ({ default: module.FormuIntEdit })))
const Packaging = lazy(() => import('pages/Configuration/views/Packaging'))
const Configuration = lazy(() => import('pages/Configuration/Configuration'))
const FormsView = lazy(() => import('pages/Entry_and_exit_forms/View/FormsView'))
const EntryMovement = lazy(() => import('pages/Pass-Form/View/EntryMovement').then(module => ({ default: module.EntryMovement })))
const FormExit = lazy(() => import('pages/Entry_and_exit_forms/FormExit/FormExit'))
const GestionUsuarios = lazy(() => import('pages/Gestion_User/GestionUsuarios').then(module => ({ default: module.GestionUsuarios })))
const CustomsClearance = lazy(() => import('pages/CustomsClearance/CustomsClearance'))
const DashboardViewP = lazy(() => import('../pages/Dashboard/view/DashboardViewP').then(module => ({ default: module.DashboardViewP })))
const PreductoInterno = lazy(() => import('pages/RefProductInter/PreductoInterno').then(module => ({ default: module.PreductoInterno })))
const FormEntry = lazy(() => import('../pages/Entry_and_exit_forms/FormEntry/FormEntry'))
const FormCustomsClearance = lazy(() => import('pages/CustomsClearance/FormCustomsClearance'))
const FormsTablesView = lazy(() => import('pages/Entry_and_exit_forms/View/FormsTablesView').then(module => ({ default: module.FormsTablesView })))
const EditProductTemplate = lazy(() => import('pages/RefProductInter/views/EditProductTemplate'))
const ShowCustomsClearance = lazy(() => import('pages/CustomsClearance/ShowCustomsClearance').then(module => ({ default: module.ShowCustomsClearance })))
const ShowExitFmm = lazy(() => import('pages/Entry_and_exit_forms/FormExit/ShowExitFmm').then(module => ({ default: module.ShowExitFmm })))
const CorrectionForm = lazy(() => import('pages/Entry_and_exit_forms/CorrectionForm/CorrectionForm'))
const CheckFmm = lazy(() => import('pages/Entry_and_exit_forms/FormExit/CheckFmm').then(module => ({ default: module.CheckFmm })))
const FormReviewing = lazy(() => import('pages/Entry_and_exit_forms/View/FormReviewing'))
const IntegracionBox = lazy(() => import('pages/IntegrationBox/IntegrationBox'))
const StatusTableView = lazy(() => import('pages/IntegrationBox/View/StatusTableView/StatusTableView'))
const InventoryControl = lazy(() => import('pages/InventoyControl/InventoryControl').then(module => ({ default: module.InventoryControl })))
const Weighing = lazy(() => import('pages/Weighing/Weighing').then(module => ({ default: module.Weighing })))
const WeighingMachine = lazy(() => import('pages/Weighing/WeighingMachine').then(module => ({ default: module.WeighingMachine })))
const ProductionOrder = lazy(() => import('pages/ProductionOrder/ProductionOrder').then(module => ({ default: module.ProductionOrder })))
const FormCreateOrder = lazy(() => import('pages/ProductionOrder/FormCreateOrder').then(module => ({ default: module.FormCreateOrder })))
const SubmittedQueue = lazy(() => import('pages/SubmittedQueue/SubmittedQueue'))
const ListDian = lazy(() => import('pages/Dian/ListDian/ListDian'))
const ProfileDocuments = lazy(() => import('pages/Dian/ProfileDocuments/ProfileDocuments'))
const ShowProductionOrder = lazy(() => import('pages/ProductionOrder/ShowProductionOrder').then(module => ({ default: module.ShowProductionOrder })))
const CheckFmmOrder = lazy(() => import('pages/ProductionOrder/CheckFmmOrder').then(module => ({ default: module.CheckFmmOrder })))
const Annexed = lazy(() => import('pages/Dian/Annexed5/Annexed'))
const ShippingForm = lazy(() => import('pages/Dian/Spreadsheet/ShippingForm'))
const Blocking = lazy(() => import('pages/Blocking/Blocking'))
const Extracts = lazy(() => import('pages/Treasury/Extracts/Extracts'))
const SalesOfService = lazy(() => import('pages/Treasury/Sales_Of_Services/SalesOfService'))
const Weigh = lazy(() => import('pages/Treasury/Weigh_Ins/Weigh'))
const Update = lazy(() => import('pages/Treasury/RateUpdate/Update'))
const FormUpdate = lazy(() => import('pages/Treasury/Forms/FormUpdate'))
const EstadisticasGeneral = lazy(() => import('pages/Statistics/General/EstadisticasGeneral').then(module => ({ default: module.EstadisticasGeneral })))
const SpecialRates = lazy(() => import('pages/Treasury/RateUpdate/SpecialRates'))
const ReturnReason = lazy(() => import('pages/ReturnReason/ReturnReason').then(module => ({ default: module.ReturnReason })))
const RecordUpdate = lazy(() => import('pages/Treasury/RateUpdate/View/RecordUpdate'))
const AuxReference = lazy(() => import('pages/InventoyControl/AuxReference').then(module => ({ default: module.AuxReference })))
const InventoryInProcess = lazy(() => import('pages/InventoyControl/InventoryInProcess').then(module => ({ default: module.InventoryInProcess })))
const AuxOutputs = lazy(() => import('pages/InventoyControl/AuxOutputs').then(module => ({ default: module.AuxOutputs })))
const TemporaryAux = lazy(() => import('pages/InventoyControl/TemporaryAux').then(module => ({ default: module.TemporaryAux })))
const InventoryProduct = lazy(() => import('pages/InventoyControl/InventoryProduct').then(module => ({ default: module.InventoryProduct })))
const ShowIntegrationBox = lazy(() => import('pages/IntegrationBox/View/ShowIntegrationBox/ShowIntegrationBox'))
const ShowWeighing = lazy(() => import('pages/Weighing/ShowWeighing').then(module => ({ default: module.ShowWeighing })))
const AuxBalance = lazy(() => import('pages/InventoyControl/AuxBalance').then(module => ({ default: module.AuxBalance })))
const ReportWeighing = lazy(() => import('pages/Weighing/ReportWeighing/ReportWeighing').then(module => ({ default: module.ReportWeighing })))
const EstadisticasSecurity = lazy(() => import('pages/Statistics/security/EstadisticasSecurity').then(module => ({ default: module.EstadisticasSecurity })))
const ItemProfile = lazy(() => import('pages/Dian/view/ProfileView/ItemProfile'))
const Dane = lazy(() => import('pages/Dane/Dane').then(module => ({ default: module.Dane })))
const FinishProfiling = lazy(() => import('pages/Dian/view/ProfileView/FinishProfiling'))
const ViewCorrectForm = lazy(() => import('pages/Entry_and_exit_forms/CorrectionForm/ViewCorrectForm').then(module => ({ default: module.ViewCorrectForm })))
const ItemProfileFinish = lazy(() => import('pages/Dian/view/ProfileView/ItemProfileFinish'))
const CheckIntegrationBox = lazy(() => import('pages/IntegrationBox/View/ShowIntegrationBox/CheckIntegrationBox'))
const CorrectionFmmO = lazy(() => import('pages/Entry_and_exit_forms/CorrectionFMMO/CorrectionFmmO').then(module => ({ default: module.CorrectionFmmO })))
const MainCorrection = lazy(() => import('../pages/Reviews/MainCorrection').then(module => ({ default: module.MainCorrection })))
const ViewCorrection = lazy(() => import('pages/IntegrationBox/CorrectionCertificate/ViewCorrection'))
const CargoVehicle = lazy(() => import('pages/Statistics/cargoVehicle/CargoVehicle').then(module => ({ default: module.CargoVehicle })))
const EstadisticasIngresoSalida = lazy(() => import('pages/Statistics/estadisticaOpeIngresoSalida/EstadisticasIngresoSalida').then(module => ({ default: module.EstadisticasIngresoSalida })))
const ReviewCorrectEntry = lazy(() => import('pages/Entry_and_exit_forms/CorrectionForm/ReviewCorrectEntry'))
const OperationsUsed = lazy(() => import('pages/Statistics/operationsUsed/OperationsUsed').then(module => ({ default: module.OperationsUsed })))
const ReviewCorrectionFmmO = lazy(() => import('pages/Entry_and_exit_forms/CorrectionFMMO/ReviewCorrectionFmmO').then(module => ({ default: module.ReviewCorrectionFmmO })))
const FormsCorrected = lazy(() => import('pages/IntegrationBox/CorrectionCertificate/FormsCorrected'))
const UpdateReview = lazy(() => import('pages/Reviews/UpdateReview/UpdateReview').then(module => ({ default: module.UpdateReview })))
const EstadisticaQualifiedUser = lazy(() => import('pages/Statistics/qualifiedUser/EstadisticaQualifiedUser').then(module => ({ default: module.EstadisticaQualifiedUser })))
const EstadisticaMovimiento = lazy(() => import('pages/Statistics/movimiento/EstadisticaMovimiento').then(module => ({ default: module.EstadisticaMovimiento })))
const ControlAnalysis = lazy(() => import('components/ControlAnalysis/main').then(module => ({ default: module.ControlAnalysis })))
const Profile = lazy(() => import('components/Profile/Profile'))
const ReviewAproved = lazy(() => import('pages/Reviews/ReviewAprovedEntry').then(module => ({ default: module.ReviewAproved })))
const ReviewCorrections = lazy(() => import('pages/Reviews/ReviewCorrections').then(module => ({ default: module.ReviewCorrections })))
const NoFound = lazy(() => import('components/NoFound/NoFound').then(module => ({ default: module.NoFound })))
const InventoryAudit = lazy(() => import('pages/InventoyControl/InventoryAudit').then(module => ({ default: module.InventoryAudit })))
const Monitoring = lazy(() => import('pages/Seguimiento/Monitoring').then(module => ({ default: module.Monitoring })))
const DashboardPage = lazy(() => import('DashBoard/pages/DashboardPage'))
const ExplorePage = lazy(() => import('DashBoard/pages/ExplorePage'))
const ModeRobot = lazy(() => import('components/ModeRobot/ModeRobot').then(module => ({ default: module.ModeRobot })))
const CheckPass = lazy(() => import('pages/Pass-Form/CheckPass'))
const EntryMovementReviw = lazy(() => import('pages/Pass-Form/View/EntryMovementReviw').then(module => ({ default: module.EntryMovementReviw })))
const FollowOrder = lazy(() => import('pages/Seguimiento/FollowOrder').then(module => ({ default: module.FollowOrder })))
const HistoryFmm = lazy(() => import('pages/HistoryFmm/Index').then(module => ({ default: module.HistoryFmm })))
const ShowRiskLevel = lazy(() => import('components/ControlAnalysis/ShowRiskLevel'))
const ShowRiskLevelUser = lazy(() => import('components/ControlAnalysis/ShowRiskLevelUser'))
const DocuExportPro = lazy(() => import('components/DocuExportPro/DocuExportPro').then(module => ({ default: module.DocuExportPro })))
const IntegrationCertificateReview = lazy(() => import('pages/IntegrationBox/View/ShowIntegrationBox/IntegrationCertificateReview').then(module => ({ default: module.IntegrationCertificateReview })))
const EstadisticaCese = lazy(() => import('pages/Statistics/Cese/EstadisticaCese'))
const FormatSRT = lazy(() => import('pages/FormatSTR/FormatSRT'))
const DEI = lazy(() => import('pages/DEI/DEI'))
const DispatchCorrectionsMain = lazy(() => import('components/DispatchCorrections/DispatchCorrectionsMain').then(module => ({ default: module.DispatchCorrectionsMain })))
const DispatchCorrectionsShow = lazy(() => import('components/DispatchCorrections/DispatchCorrectionsShow'))
const UsersWeighing = lazy(() => import('pages/Weighing/view/UsersWeighing'))
const OperationsStatistics = lazy(() => import('pages/Statistics/Operations/OperationsStatistics'))
const Reports = lazy(() => import('pages/Weighing/view/Components/Reports'))
const EstadisticasOpeIO = lazy(() => import('pages/Statistics/operaciones/EstadisticasOpeIO'))

// const { movement = "" } = queryString.parse(location.search);

export const privateRouteZF = [
  {
    path: '/monitoring',
    breadcrumbName: 'Seguimiento',
    element: (
      <MonitoringContextProvider>
        <FormCrudCRUDProvider>
          <ThirdPartiesProvider>
            <Monitoring />
          </ThirdPartiesProvider>
        </FormCrudCRUDProvider>
      </MonitoringContextProvider>
    )
  },
  {
    path: '/followOrder',
    breadcrumbName: 'Gestor de seguimiento',
    element: (
      <MonitoringContextProvider>
        <ThirdPartiesProvider>
          <FollowOrder />
        </ThirdPartiesProvider>
      </MonitoringContextProvider>
    )
  },
  {
    path: '/profilee',
    breadcrumbName: 'Perfil',
    element: (
      <FormCrudCRUDProvider>
        <Profile />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/control-analysis',
    breadcrumbName: 'Análisis de control',
    element: (
      <ControlAnalysisProvider>
        <ControlAnalysis />
      </ControlAnalysisProvider>
    )
  },
  {
    path: '/ShowRiskLevel',
    breadcrumbName: 'Análisis de control',
    element: <ShowRiskLevel />
  },
  {
    path: '/ShowRiskLevelUser',
    breadcrumbName: 'Análisis de control',
    element: <ShowRiskLevelUser />
  },
  {
    path: '/config/*',
    breadcrumbName: 'Configuración',
    element: (
      <SuperAdminRoutes>
        <ConfigurationCRUDProvider>
          <Configuration />
        </ConfigurationCRUDProvider>
      </SuperAdminRoutes>
    )
  },
  {
    path: '/unit',
    breadcrumbName: 'Unidad',
    element: (
      <ProductCRUDProvider>
        <Unidad />
      </ProductCRUDProvider>
    )
  },
  // {
  //   path: "/pesaje",
  //   breadcrumbName: "Pesaje",
  //   element: <Pesaje />,
  // },
  {
    path: '/product-int',
    breadcrumbName: 'Referencia de producto',
    element: (
      <FormCrudCRUDProvider>
        <ProductCRUDProvider>
          <ThirdPartiesProvider>
            <PreductoInterno />
          </ThirdPartiesProvider>
        </ProductCRUDProvider>
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/edit-product-template',
    breadcrumbName: 'Proceso productivo',
    element: (
      <FormCrudCRUDProvider>
        <ProductCRUDProvider>
          <ProcessCrudProvider>
            <EditProductTemplate />
          </ProcessCrudProvider>
        </ProductCRUDProvider>
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/third-parties',
    breadcrumbName: 'Terceros',
    element: (
      <FormCrudCRUDProvider>
        <ProductCRUDProvider>
          <ThirdPartiesProvider>
            <ThirdParties />
          </ThirdPartiesProvider>
        </ProductCRUDProvider>
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/customsClearance',
    breadcrumbName: 'Desaduanamiento',
    element: (
      <CustomsCrudProvider>
        <ThirdPartiesProvider>
          <CustomsClearance />
        </ThirdPartiesProvider>
      </CustomsCrudProvider>
    )
  },

  {
    path: '/HistoryFmm',
    breadcrumbName: 'Historial de formulario de movimiento de mercancia',
    element: <HistoryFmm />
  },
  {
    path: '/formCustomsClearance',
    breadcrumbName: 'Formulario desaduanamiento',
    element: (
      <CustomsCrudProvider>
        <FormCustomsClearance />
      </CustomsCrudProvider>
    )
  },
  {
    path: '/ShowCustomsClearance',
    breadcrumbName: 'Ver desaduanamiento',
    element: (
      <CustomsCrudProvider>
        <ShowCustomsClearance />
      </CustomsCrudProvider>
    )
  },
  {
    path: '/packaging',
    breadcrumbName: 'Embalaje',
    element: <Packaging />
  },
  {
    path: '/pases',
    breadcrumbName: 'Pases',
    element: (
      <FormCrudCRUDProvider>
        <PassCrudProvider>
          <Pases />
        </PassCrudProvider>
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/CheckPassEntry',
    breadcrumbName: 'Revisar pases entrada',
    element: (
      <FormCrudCRUDProvider>
        <PassCrudProvider>
          <CheckPass />
        </PassCrudProvider>
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/CheckPassOutput',
    breadcrumbName: 'Revisar pases salida',
    element: (
      <FormCrudCRUDProvider>
        <PassCrudProvider>
          <CheckPass />
        </PassCrudProvider>
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/gestion-user',
    breadcrumbName: 'Gestión de usuario',
    element: (
      <GestionCrudProvider>
        <GestionUsuarios />
      </GestionCrudProvider>
    )
  },
  {
    path: '/',
    element: <DashboardViewP />,
    breadcrumbName: 'Resumen de Actividad'
  },

  {
    path: '/entry-movement',
    breadcrumbName: 'Movimiento de entrada',
    element: (
      <PassCrudProvider>
        <ThirdPartiesProvider>
          <EntryMovement />
        </ThirdPartiesProvider>
      </PassCrudProvider>
    )
  },

  {
    path: '/corrected-pass-exit',
    breadcrumbName: 'Corregidos de despacho',
    element: (
      <ThirdPartiesProvider>
        <DispatchCorrectionsMain />
      </ThirdPartiesProvider>
    )
  },

  {
    path: '/entry-movement-review',
    breadcrumbName: 'Revisión de entrada',
    element: (
      <PassCrudProvider>
        <ThirdPartiesProvider>
          <EntryMovementReviw />
        </ThirdPartiesProvider>
      </PassCrudProvider>
    )
  },
  {
    path: '/output-movement',
    breadcrumbName: 'Movimiento de salida',
    element: (
      <PassCrudProvider>
        <ThirdPartiesProvider>
          <EntryMovement />
        </ThirdPartiesProvider>
      </PassCrudProvider>
    )
  },
  {
    path: '/output-movement-review',
    breadcrumbName: 'Revisión de salida',
    element: (
      <PassCrudProvider>
        <ThirdPartiesProvider>
          <EntryMovementReviw />
        </ThirdPartiesProvider>
      </PassCrudProvider>
    )
  },
  {
    path: '/Form-tables-entry',
    breadcrumbName: 'Formulario ingreso',
    element: (
      <ThirdPartiesProvider>
        <FormCrudCRUDProvider>
          <FormsTablesView />
        </FormCrudCRUDProvider>
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/Form-tables-output',
    breadcrumbName: 'Formulario salida',
    element: (
      <ThirdPartiesProvider>
        <FormCrudCRUDProvider>
          <FormsTablesView />
        </FormCrudCRUDProvider>
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/Correct-Form',
    breadcrumbName: 'Formulario corregidos',
    element: (
      <ThirdPartiesProvider>
        <FormCrudCRUDProvider>
          <ViewCorrectForm />
        </FormCrudCRUDProvider>
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/Correct-Form-output',
    breadcrumbName: 'Formulario corregidos',
    element: (
      <ThirdPartiesProvider>
        <FormCrudCRUDProvider>
          <ViewCorrectForm />
        </FormCrudCRUDProvider>
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/formInt',
    breadcrumbName: 'Editar formulario',
    element: (
      <PassCrudProvider>
        <FormuIntEdit />
      </PassCrudProvider>
    )
  },
  {
    path: '/FormEntry',
    breadcrumbName: 'Formulario de ingreso',
    element: (
      <ThirdPartiesProvider>
        <FormCrudCRUDProvider>
          <ProductCRUDProvider>
            <FormEntry />
          </ProductCRUDProvider>
        </FormCrudCRUDProvider>
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/FormExit',
    breadcrumbName: 'Formulario de salida',
    element: (
      <ThirdPartiesProvider>
        <FormCrudCRUDProvider>
          <IntegracionBoxCRUDProvider>
            <FormExit />
          </IntegracionBoxCRUDProvider>
        </FormCrudCRUDProvider>
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/DispathcCorrectionShow',
    breadcrumbName: 'Ver correcciones de despacho',
    element: <DispatchCorrectionsShow />
  },
  {
    path: '/FormShow',
    breadcrumbName: 'Ver formulario',
    element: (
      <MonitoringContextProvider>
        <PassCrudProvider>
          <FormCrudCRUDProvider>
            <FormsView />
          </FormCrudCRUDProvider>
        </PassCrudProvider>
      </MonitoringContextProvider>
    )
  },
  {
    path: '/FormCorrection',
    breadcrumbName: 'Corrección de Formulario de ingreso',
    element: (
      <FormCrudCRUDProvider>
        <CorrectionForm />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/FormCorrectionOutput',
    breadcrumbName: 'Corrección de Formulario de salida',
    element: (
      <FormCrudCRUDProvider>
        <CorrectionFmmO />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/FormShowExit',
    breadcrumbName: 'Ver formulario',
    element: (
      <MonitoringContextProvider>
        <PassCrudProvider>
          <FormCrudCRUDProvider>
            <ShowExitFmm />
          </FormCrudCRUDProvider>
        </PassCrudProvider>
      </MonitoringContextProvider>
    )
  },
  {
    path: '/CheckForm',
    breadcrumbName: 'Revisar salida',
    element: (
      <FormCrudCRUDProvider>
        <CheckFmm />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/CheckFormEntry',
    breadcrumbName: 'Revisar ingreso',
    element: (
      <FormCrudCRUDProvider>
        <FormReviewing />
      </FormCrudCRUDProvider>
    )
  },
  /* Inicio de Revisión */
  {
    path: '/review-entry',
    breadcrumbName: 'Revisión de ingreso',
    element: (
      <FormCrudCRUDProvider>
        <MainCorrection />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/review-exit',
    breadcrumbName: 'Revisión de Salida',
    element: (
      <FormCrudCRUDProvider>
        <MainCorrection />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/review-FormEntry-Authorize',
    breadcrumbName: 'Revisión Aprobados de Ingreso',
    element: (
      <FormCrudCRUDProvider>
        <ReviewAproved />
      </FormCrudCRUDProvider>
    )
  },
  /*   {
    path: "/review-FormOutput-Authorize",
    breadcrumbName: "Revisión Salida de Aprobados",
    element: (
      <FormCrudCRUDProvider>
        <ReviewAproved />
      </FormCrudCRUDProvider>
    ),
  }, */
  {
    path: '/review-Integration',
    breadcrumbName: 'Revisión Certificado de integración',
    element: (
      <FormCrudCRUDProvider>
        <MainCorrection />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/review-FormEntry-Correcteds',
    breadcrumbName: 'Corrección de ingreso',
    element: (
      <FormCrudCRUDProvider>
        <ReviewCorrections />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/review-FormOutput-Correcteds',
    breadcrumbName: 'Corrección de Salida',
    element: (
      <FormCrudCRUDProvider>
        <ReviewCorrections />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/CheckCorrectEntry',
    breadcrumbName: 'Corrección de Ingreso',
    element: (
      <FormCrudCRUDProvider>
        <ReviewCorrectEntry />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/CheckCorrectOutput',
    breadcrumbName: 'Revisar ingreso',
    element: (
      <FormCrudCRUDProvider>
        <ReviewCorrectionFmmO />
      </FormCrudCRUDProvider>
    )
  },
  {
    path: '/Update-review',
    breadcrumbName: 'Actualizar Revisión',
    element: (
      <FormCrudCRUDProvider>
        <UpdateReview />
      </FormCrudCRUDProvider>
    )
  },
  /* Fin de Revisión */

  {
   /*  path: '/IntegracionBox',
    breadcrumbName: 'Certificado de integración',
    element: (
      <IntegracionBoxCRUDProvider>
        <OrderProductionProvider>
          <IntegracionBox />
        </OrderProductionProvider>
      </IntegracionBoxCRUDProvider>
    ) */
  },

  {
    path: '/CheckIntegrationBox',
    breadcrumbName: 'Revisar certificado de integración',
    element: (
      <IntegracionBoxCRUDProvider>
        <OrderProductionProvider>
          <CheckIntegrationBox />
        </OrderProductionProvider>
      </IntegracionBoxCRUDProvider>
    )
  },

  {
    path: '/TabletIntegration',
    breadcrumbName: 'Estado de certificados de integración',
    element: (
      <IntegracionBoxCRUDProvider>
        <OrderProductionProvider>
          <ThirdPartiesProvider>
            <StatusTableView />
          </ThirdPartiesProvider>
        </OrderProductionProvider>
      </IntegracionBoxCRUDProvider>
    )
  },

  {
    path: '/TabletIntegrationCorrected',
    breadcrumbName: 'Certificados de integración corregido',
    element: (
      <IntegracionBoxCRUDProvider>
        <OrderProductionProvider>
          <ThirdPartiesProvider>
            <FormsCorrected />
          </ThirdPartiesProvider>
        </OrderProductionProvider>
      </IntegracionBoxCRUDProvider>
    )
  },

  {
    /* path: '/ShowIntegrationBox',
    breadcrumbName: 'Ver certificado de integración',
    element: (
      <IntegracionBoxCRUDProvider>
        <OrderProductionProvider>
          <ShowIntegrationBox />
        </OrderProductionProvider>
      </IntegracionBoxCRUDProvider>
    ) */
  },
  {
    path: '/IntegrationCertificateReview',
    breadcrumbName: 'Revision',
    element: (
      <IntegracionBoxCRUDProvider>
        <OrderProductionProvider>
          <IntegrationCertificateReview />
        </OrderProductionProvider>
      </IntegracionBoxCRUDProvider>
    )
  },

  {
    path: '/CorrectedCertificate',
    breadcrumbName: 'Corrección certificados de integración',
    element: (
      <IntegracionBoxCRUDProvider>
        <OrderProductionProvider>
          <ViewCorrection />
        </OrderProductionProvider>
      </IntegracionBoxCRUDProvider>
    )
  },

  {
    path: '/inventario',
    breadcrumbName: 'Inventario',
    element: (
      <InventoryControlProvider>
        <ThirdPartiesProvider>
          <InventoryControl />
        </ThirdPartiesProvider>
      </InventoryControlProvider>
    )
  },

  {
    path: '/InventoryInProcess',
    breadcrumbName: 'Inventario en trámite',
    element: (
      <ThirdPartiesProvider>
        <InventoryInProcess />
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/auxReference',
    breadcrumbName: 'Auxiliar referencia',
    element: (
      <ThirdPartiesProvider>
        <AuxReference />
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/auxBalance',
    breadcrumbName: 'Auxiliar saldo',
    element: (
      <ThirdPartiesProvider>
        <AuxBalance />
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/auxOutputs',
    breadcrumbName: 'Auxiliar salidas',
    element: (
      <ThirdPartiesProvider>
        <AuxOutputs />
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/temporaryAux',
    breadcrumbName: 'Auxiliar temporales',
    element: (
      <ThirdPartiesProvider>
        <TemporaryAux />
      </ThirdPartiesProvider>
    )
  },
  {
    path: '/inventarioProduc',
    breadcrumbName: 'Producto',
    element: (
      <ThirdPartiesProvider>
        <InventoryProduct />
      </ThirdPartiesProvider>
    )
  },

  {
    path: '/AuditoriaDeInventario',
    breadcrumbName: 'Auditoria de inventario',
    element: (
      <InventoryControlProvider>
        <ThirdPartiesProvider>
          <InventoryAudit />
        </ThirdPartiesProvider>
      </InventoryControlProvider>
    )
  },

  {
    path: '/pesaje',
    breadcrumbName: 'Pesaje',
    element: (
      <WeighingProvider>
        <ThirdPartiesProvider>
          <Weighing />
        </ThirdPartiesProvider>
      </WeighingProvider>
    )
  },
  {
    path: '/ReporteBascula',
    breadcrumbName: 'Reporte báscula',
    element: (
      <WeighingProvider>
        <ThirdPartiesProvider>
          <ReportWeighing />
        </ThirdPartiesProvider>
      </WeighingProvider>
    )
  },
  {
    path: '/Reports',
    breadcrumbName: 'Reporte de salida por puerta liviano',
    element: (
      <WeighingProvider>
        <ThirdPartiesProvider>
          <Reports />
        </ThirdPartiesProvider>
      </WeighingProvider>
    )
  },
  {
    path: '/Basculas',
    breadcrumbName: 'Básculas',
    element: <WeighingMachine />
  },
  {
    path: '/ShowWeighing',
    breadcrumbName: 'Ver tiquete',
    element: <ShowWeighing />
  },

  {
    path: '/Blocking',
    breadcrumbName: 'Bloqueos',
    element: (
      <BlockingCRUDProvider>
        <ThirdPartiesProvider>
          <Blocking />
        </ThirdPartiesProvider>
      </BlockingCRUDProvider>
    )
  },

  {
    path: '/CrearOrdenDeProduccion',
    breadcrumbName: 'Editar orden de producción',
    element: (
      <IntegracionBoxCRUDProvider>
        <OrderProductionProvider>
          <FormCreateOrder />
        </OrderProductionProvider>
      </IntegracionBoxCRUDProvider>
    )
  },
  {
    path: '/VerOrdenDeProduccion',
    breadcrumbName: 'Ver orden de producción',
    element: (
      <OrderProductionProvider>
        <ShowProductionOrder />
      </OrderProductionProvider>
    )
  },
  {
    path: '/RevisarOrdenDeProduccion',
    breadcrumbName: 'Revisar orden de producción',
    element: (
      <OrderProductionProvider>
        <CheckFmmOrder />
      </OrderProductionProvider>
    )
  },
  {
    path: '/OrdenDeProduccion',
    breadcrumbName: 'Orden de producción',
    element: (
      <OrderProductionProvider>
        <ThirdPartiesProvider>
          <ProductionOrder />
        </ThirdPartiesProvider>
      </OrderProductionProvider>
    )
  },
  {
    path: '/security/*',
    breadcrumbName: 'Seguridad',
    element: <SecurityRoutes />
  },

  {
    path: '/Coladepresentados',
    breadcrumbName: 'Cola de documentos presentados',
    element: <SubmittedQueue />
  },

  {
    path: '/Perfilardocumento',
    breadcrumbName: 'Perfilado de documento',
    element: (
      <DianCRUDProvider>
        <ThirdPartiesProvider>
          <ProfileDocuments />
        </ThirdPartiesProvider>
      </DianCRUDProvider>
    )
  },

  {
    path: '/FinalizarPerfilamiento',
    breadcrumbName: 'Finalizar Perfilamiento',
    element: (
      <DianCRUDProvider>
        <FinishProfiling />,
      </DianCRUDProvider>
    )
  },

  {
    path: '/PerfilarItemsDocument',
    breadcrumbName: 'Ítem  en perfilamiento',
    element: (
      <DianCRUDProvider>
        <ItemProfile />,
      </DianCRUDProvider>
    )
  },
  {
    path: '/Anexo',
    breadcrumbName: 'Anexo 5',
    element: (
      <DianCRUDProvider>
        <ThirdPartiesProvider>
          <Annexed />
        </ThirdPartiesProvider>
      </DianCRUDProvider>
    )
  },

  {
    path: '/Listadodian',
    breadcrumbName: 'Reporte listado DIAN',
    element: (
      <DianCRUDProvider>
        <ListDian />,
      </DianCRUDProvider>
    )
  },
  {
    path: '/Planilladeenvio',
    breadcrumbName: 'Planilla de envio',
    element: (
      <DianCRUDProvider>
        <ShippingForm />,
      </DianCRUDProvider>
    )
  },

  {
    path: '/ProfileFinish',
    breadcrumbName: 'Items perfilados',
    element: (
      <DianCRUDProvider>
        <ItemProfileFinish />
      </DianCRUDProvider>
    )
  },

  {
    path: '/Extractos',
    breadcrumbName: 'Extractos',
    element: (
      <TreasuryCRUDProvider>
        <ThirdPartiesProvider>
          <Extracts />
        </ThirdPartiesProvider>
      </TreasuryCRUDProvider>
    )
  },

  {
    path: '/VentasDeServicios',
    breadcrumbName: 'Ventas de Servicios',
    element: (
      <TreasuryCRUDProvider>
        <ThirdPartiesProvider>
          <SalesOfService />
        </ThirdPartiesProvider>
      </TreasuryCRUDProvider>
    )
  },

  {
    path: '/ActualizacionDeTarifa',
    breadcrumbName: 'Actualización de tarifas',
    element: (
      <TreasuryCRUDProvider>
        <Update />
      </TreasuryCRUDProvider>
    )
  },

  {
    path: '/FormActualizacionDeTarifa',
    breadcrumbName: 'Actualización de tarifas',
    element: (
      <TreasuryCRUDProvider>
        <FormUpdate />
      </TreasuryCRUDProvider>
    )
  },

  {
    path: '/TarifasEspeciales',
    breadcrumbName: 'Tarifas especiales',
    element: (
      <TreasuryCRUDProvider>
        <SpecialRates />
      </TreasuryCRUDProvider>
    )
  },
  {
    path: '/Pesajes',
    breadcrumbName: 'Pesajes',
    element: (
      <TreasuryCRUDProvider>
        <ThirdPartiesProvider>
          <Weigh />
        </ThirdPartiesProvider>
      </TreasuryCRUDProvider>
    )
  },
  {
    path: '/Record',
    breadcrumbName: 'Historial de actualización tarifas',
    element: (
      <TreasuryCRUDProvider>
        <RecordUpdate />
      </TreasuryCRUDProvider>
    )
  },

  {
    path: '/EstadisticasGeneral',
    breadcrumbName: 'Estadísticas general',
    element: <EstadisticasGeneral />
  },
  {
    path: '/EstadisticasOpeIngSal',
    breadcrumbName: 'Estadísticas operaciones utilizadas',
    element: <OperationsUsed />
  },
  {
    //breadcrumbName: "Estadísticas documentos por Ope. Ingresos y salidas",
    path: '/EstadisticasAdmin',
    breadcrumbName: 'Estadísticas de Ope. Ingresos y Salidas',
    element: (
      <StatisProvider>
        <EstadisticasIngresoSalida />
      </StatisProvider>
    )
  },
  {
    path: '/EstadisticasOperacionesUsadas',
    breadcrumbName: 'Estadísticas de operaciones en documentos',
    element: <EstadisticasOpeIO />
  },
  {
    path: '/EstadisticasCargoVehicle',
    breadcrumbName: 'Estadísticas vehículo',
    element: <CargoVehicle />
  },
  {
    path: '/EstadisticasSeguridad',
    breadcrumbName: 'Estadísticas seguridad',
    element: <EstadisticasSecurity />
  },
  {
    path: '/EstadisticasQualifiedUser',
    breadcrumbName: 'Estadísticas Usuarios calificados',
    element: <EstadisticaQualifiedUser />
  },
  {
    path: '/EstadisticasMovimiento',
    breadcrumbName: 'Estadísticas movimientos',
    element: <EstadisticaMovimiento />
  },
  {
    path: '/EstadisticasCese',
    breadcrumbName: 'Estadística de cese de actividades',
    element: <EstadisticaCese />
  },
  {
    path: "/EstadisticasOperaciones",
    breadcrumbName: "Estadísticas de Operaciones",
    element: <OperationsStatistics />
  },
  {
    path: "/EstadisticasOperacionesGeneral",
    breadcrumbName: "Estadísticas operaciones global",
    element: <EstadisticasOperacionesGeneral />
  },
  {
    path: '/DocuExportPro',
    breadcrumbName: 'Exportar Documentos',
    element: <DocuExportPro />
  },

  {
    path: '/motivodevolucion',
    breadcrumbName: 'Motivo de devolución',
    element: (
      <ReturnReasonnProvider>
        <ThirdPartiesProvider>
          <ReturnReason />
        </ThirdPartiesProvider>
      </ReturnReasonnProvider>
    )
  },
  {
    path: '/dane',
    breadcrumbName: 'Estadisticas DANE',
    element: <Dane />
  },
  {
    path: '/dashboard',
    breadcrumbName: 'Panel de Control',
    element: <DashboardPage />
  },
  {
    path: '/Robot-mode',
    breadcrumbName: 'Modo en Robot',
    element: <ModeRobot />
  },
  {
    path: '/explore',
    breadcrumbName: 'Edición de gráficos',
    element: <ExplorePage />
  },
  {
    path: '/FormatSRT',
    breadcrumbName: 'Formato SRT',
    element: (
      <GlobalContextProvider>
        <FormCrudCRUDProvider>
          <FormatSRT />
        </FormCrudCRUDProvider>
      </GlobalContextProvider>
    )
  },
  {
    path: '/DEI',
    breadcrumbName: 'Declaración especial de importación',
    element: <DEI />
  },
  // Ruta No encontrada
  {
    path: '*',
    breadcrumbName: 'Ruta No encontrada',
    element: <NoFound />
  },

  {
    path: '/UsuarioBascula',
    breadcrumbName: 'Conf. Usuario Báscula',
    element: (
      <GlobalContextProvider>
        <ConfigurationCRUDProvider>
          <UsersWeighing />
        </ConfigurationCRUDProvider>
      </GlobalContextProvider>
    )
  }
]

const renewTokenChannel = new BroadcastChannel('renew-token-channel')
export const privateRouterZFEdit = [...privateRouteZF]

const RoutePrivateZF = props => {
  const altoht = document.documentElement.scrollHeight
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [collaps, setCollaps] = useState(true)
  const location = useLocation()
  const [openAlert] = AlertErrorAlert()
  const [modalOpen, setModalOpen] = useState(false)

  const [isOpenModalExpired, onOpenModalExpired, onCloseModalExpired] =
    useModal()
  const token = useSelector(state => state.auth.dataUser.token)
  const dispacthRedux = useDispatch()
  const navigate = useNavigate()
  const idFuncionaio = useSelector(state => state.auth.dataUser.id)
  const { ciModuleDynamic } = useSelector((state) => state?.form) || {};

  renewTokenChannel.onmessage = event => {
    dispacthRedux(updateToken(event?.data))
  }

  useEffect(() => {
    const ModeRobot = GetLocalStorage('Mode_Robot')
    let router_current = ''
    const allowedRoutes = [
      '/CheckFormEntry',
      '/CheckForm',
      '/FormShow',
      '/FormShowExit',
      '/FormCorrection',
      '/FormCorrectionOutput',
      '/ShowIntegrationBox',
      '/Robot-mode',
      '/CheckCorrectEntry',
      '/CheckCorrectOutput'
    ]
    router_current = allowedRoutes.includes(location.pathname)

    if (ModeRobot && router_current) {
    } else {
      ADDLocalStorage(false, 'Mode_Robot')
    }
  }, [location])

  const { date_expires } = useSelector(state => state.auth.dataUser)
  useEffect(() => {
    const checkTokenExpiration = () => {
      const expirationDate = new Date(date_expires)
      const currentTime = new Date()
      const timeDiffInMilliseconds = expirationDate - currentTime
      const timeDiffInMinutes = Math.floor(timeDiffInMilliseconds / (1000 * 60))

      /* console.log({ expirationDate, currentTime, timeDiffInMinutes, date_expires }); */

      if (timeDiffInMinutes === 0) {
        handleLogout(token, () => {}, dispacthRedux, navigate, idFuncionaio)
        openAlert(
          'Tu token ha expirado. Por favor, inicia sesión nuevamente para continuar'
        )
      }

      // Evitar alertas repetidas dentro de un corto período
      if (timeDiffInMinutes <= 5 && timeDiffInMinutes >= 0 && !modalOpen) {
        openAlert(
          `¡Atención! Tu token está a punto de expirar en ${timeDiffInMinutes} minutos. Por favor, asegúrate de renovarlo a tiempo`
        )
        setModalOpen(true)
        onOpenModalExpired()
      }
    }

    // Verificar inmediatamente al cargar el componente
    checkTokenExpiration()

    // Intervalo de verificación ajustado (cada minuto)
    const intervalId = setInterval(checkTokenExpiration, 60 * 1000)

    return () => {
      clearInterval(intervalId)
    }
  }, [date_expires])

  const redirectRouter = () => {
    const redirectUrl = localStorage.getItem("redirectUrl") || null;
    localStorage.removeItem("redirectUrl");
    if (isValid(redirectUrl)) navigate(redirectUrl);
  };

  useEffect(() => {
    redirectRouter()
  }, []);

  const ciTitle = {
    showName: "Ver certificado de integración",
    editName: "Certificado de integración",
  };
  const breadcrumbNameShow = ciModuleDynamic?.nameModul
    ? `Ver ${ciModuleDynamic.nameModul}`
    : ciTitle.showName;

  const breadcrumbNameEdit = ciModuleDynamic?.nameModul
    ? `Editar ${ciModuleDynamic.nameModul}`
    : ciTitle.editName;

  const showIntegrationBoxElement = (
    <IntegracionBoxCRUDProvider>
      <OrderProductionProvider>
        <ShowIntegrationBox />
      </OrderProductionProvider>
    </IntegracionBoxCRUDProvider>
  );

  const integrationBoxElement = (
    <IntegracionBoxCRUDProvider>
      <OrderProductionProvider>
        <IntegracionBox />
      </OrderProductionProvider>
    </IntegracionBoxCRUDProvider>
  );

  privateRouterZFEdit.splice(53, 1, {
    path: "/ShowIntegrationBox",
    breadcrumbName: breadcrumbNameShow,
    element: showIntegrationBoxElement,
  });

  privateRouterZFEdit.splice(49, 1, {
    path: "/IntegracionBox",
    breadcrumbName: breadcrumbNameEdit,
    element: integrationBoxElement,
  });

  return (
    <div className='row'>
      <div className='col-1'>
        <TokenExpirer
          isOpen={isOpenModalExpired}
          open={onOpenModalExpired}
          onClose={onCloseModalExpired}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
        />

        <FormCrudCRUDProvider>
          <Aside
            state={collaps}
            set={setCollaps}
            isAdvancedSearchModal={isOpen}
            openAdvancedSearchModal={onOpen}
            onCloseAdvancedSearchModal={onClose}
          />
        </FormCrudCRUDProvider>
      </div>

      <div className='col-11'>
        <MainStyled>
          <div className='mb-4 container'>
            <ContaianeFalse
              het={`${altoht}px`}
              className={'izq ' + (!collaps ? '' : 'oculto')}
              onClick={() => setCollaps(!collaps)}
            />
            <FormCrudCRUDProvider>
              <FirstLoginProvider>
                <Header set={setCollaps} state={collaps} />
              </FirstLoginProvider>
            </FormCrudCRUDProvider>
            <Suspense fallback={<Loading />}>
              <Routes>
                {privateRouterZFEdit.map(({ path, element }, i) => (
                  <Route key={i} path={path} element={element} />
                ))}
              </Routes>
            </Suspense>
          </div>
        </MainStyled>
      </div>
    </div>
    // pa que suba luego lo borro
  )
}
export default RoutePrivateZF
